import { DashboardColor } from '../enums/DashboardColor';
import { DefaultAttributeType } from '../enums/DefaultAttributeType';

export const mainColors: { [key: string]: string } = {
  yellow: '#F7CF69',
  gray: '#E9EEF5',
  darkGray: '#9BA6B2',
  green: '#51BF77',
  blue: '#2C99FE',
  blackBlue: '#0343A3',
  violet: '#7B8ABA'
};

export const dashboardColors: Record<DashboardColor, { color: string; backgroundColor: string }> = {
  [DashboardColor.Neutral]: { color: '#758ABD', backgroundColor: '#F3F5FC' },
  [DashboardColor.BrightNeutral]: { color: '#A9B6D6', backgroundColor: '#F3F5FC' },
  [DashboardColor.Yellow]: { color: '#F99A06', backgroundColor: '#FEF5E6' },
  [DashboardColor.Green]: { color: '#1AB299', backgroundColor: '#EBF9F7' },
  [DashboardColor.Blue]: { color: '#21A4FC', backgroundColor: '#E5F5FF' },
  [DashboardColor.Purple]: { color: '#5A73F2', backgroundColor: '#E7EBFD' }
};

export const getAttributeColors = (type: string) => {
  switch (type) {
    case DefaultAttributeType.Foundational:
      return { color: 'var(--yellow-600)', backgroundColor: 'var(--yellow-100)' };
    case DefaultAttributeType.Interpersonal:
      return { color: 'var(--green-600)', backgroundColor: 'var(--green-100)' };
    case DefaultAttributeType.CriticalThinking:
      return { color: 'var(--primary-600)', backgroundColor: 'var(--primary-100)' };
    case DefaultAttributeType.Management:
      return { color: 'var(--purple-600)', backgroundColor: 'var(--purple-100)' };
    default:
      return { color: 'var(--neutral-600)', backgroundColor: 'var(--neutral-100)' };
  }
};

export const neutralGrayPalette = {
  '--neutral-100': '#F9F9F9',
  '--neutral-200': '#F0F0F0',
  '--neutral-300': '#BFBFBF',
  '--neutral-400': '#999999',
  '--neutral-500': '#999999',
  '--neutral-600': '#999999',
  '--neutral-700': '#616161'
};

export const defaultPalette = {
  '--neutral-100': '#f3f5fc',
  '--neutral-200': '#E6EAF4',
  '--neutral-300': '#c9d2e8',
  '--neutral-400': '#a9b6d6',
  '--neutral-500': '#758ABD',
  '--neutral-600': '#4D6AB2',
  '--neutral-700': '#335199',
  '--neutral-800': '#173682',
  '--primary-600': '#21A4FC',
  '--primary-500': '#38AFFA',
  '--primary-400': '#6AC3FB',
  '--primary-300': '#9CD7FC',
  '--primary-200': '#CDEBFE',
  '--primary-100': '#E5F5FF',
  '--circle-color': '#5889FF'
};
